import React from 'react'
import { Alert } from '@mui/material'

export default function CopyScopeNotice({ summary }) {
  const summaries = Array.isArray(summary) ? summary : [summary]
  const messages = summaries.flatMap((item) => item?.partial && item.message ? [item.message] : [])
  if (messages.length === 0) return null
  return <Alert severity="warning" role="status">{messages.join(' ')}</Alert>
}
